import defaultLayout from '../../layouts/default'

export default {
  path: 'mobile',
  component: defaultLayout,
  children: [
    {
      path: 'meetingGuide',
      component: () => import('./meetingGuide'),
      meta: {
        title: 'my_meeting_card_title'
      }
    },
    {
      path: 'meetingCard',
      component: () => import('./meetingCard'),
      meta: {
        title: 'my_meeting_card_title'
      }
    }
  ]
}
